import { Link } from "react-router-dom";
import { ArrowUpRight, Sparkles } from "lucide-react";
import { ALL_FOILS, FOIL_COUNT, FOIL_SECTIONS, familyOf } from "../../lib/foilChart";
import { Panel, Cta } from "./_ui";

const PICKS = ["120", "110", "142", "144", "910", "960", "311", "409", "pw290", "hu941", "scratch off 113", "180"];

export function FoilChartTeaser() {
  const picks = PICKS.map((c) => ALL_FOILS.find((f) => f.code.toLowerCase() === c)).filter(Boolean);
  return (
    <Panel icon={Sparkles} title={`Foil stamp color chart · ${FOIL_COUNT} foils`} testId="foil-color-chart">
      <div className="grid grid-cols-3 sm:grid-cols-4 lg:grid-cols-6 gap-2" data-testid="foil-teaser-grid">
        {picks.map((f) => (
          <Link key={f.code} to={`/tools/foil-color-chart?foil=${encodeURIComponent(f.code)}`} className="group bg-black/30 border border-white/10 hover:border-[#B87333] transition-colors" data-testid={`foil-teaser-${f.code.toLowerCase().replace(/\s+/g, "-")}`}>
            <img src={f.img} alt={`Foil ${f.code}`} loading="lazy" width="300" height="110" className="w-full aspect-[300/110] object-cover" />
            <div className="px-2 py-1.5 font-mono text-[10px] tracking-[0.18em] uppercase font-bold text-white/90 group-hover:text-[#E8B587]">{f.code}</div>
          </Link>
        ))}
      </div>
      <div className="flex flex-wrap gap-2 mt-4" data-testid="foil-teaser-families">
        {FOIL_SECTIONS.map((s) => <Link key={s.id} to={`/tools/foil-color-chart?family=${s.id}`} className="font-mono text-[10px] tracking-widest uppercase border border-white/15 hover:border-[#B87333] px-2 py-1 text-white/80">{familyOf(s.id).short} · {s.foils.length}</Link>)}
      </div>
      <div className="flex flex-wrap gap-2 mt-4">
        <Cta to="/tools/foil-color-chart" testId="foil-teaser-open">Open the full chart</Cta>
        <Link to="/quote?product=Foil%20stamping&tool=foil-color-chart" className="inline-flex items-center gap-2 font-mono text-[10px] tracking-[0.22em] uppercase font-bold px-4 py-2.5 border border-white/25 hover:border-[#B87333] text-white transition-colors" data-testid="foil-teaser-quote">Request a foil quote <ArrowUpRight className="w-3.5 h-3.5" /></Link>
      </div>
    </Panel>
  );
}
